// CarDeadlineCountdown — GR §6.1 30-day countdown widget
// GAP-020 closure

import React from "react";
import { Chip, Tooltip } from "@mui/material";
import { daysUntilDeadline } from "../../utils/ncrFindingClassApi";

export default function CarDeadlineCountdown({ deadline_at }) {
  if (!deadline_at) return <Chip label="No deadline" size="small" variant="outlined" />;
  const days = daysUntilDeadline(deadline_at);
  let color = "success";
  let label = `${days}d remaining`;
  if (days == null) { color = "default"; label = "—"; }
  else if (days < 0) { color = "error"; label = `Overdue by ${Math.abs(days)}d`; }
  else if (days < 7) color = "error";
  else if (days <= 14) color = "warning";

  return (
    <Tooltip title={`Deadline: ${deadline_at} (GR §6.1: 30 days from audit close)`}>
      <Chip label={label} color={color} size="small" />
    </Tooltip>
  );
}
